import { Amplify } from 'aws-amplify';
// Registers the OAuth redirect listener eagerly, so the Hosted UI callback (`?code=...`)
// is always processed on first load, regardless of which module imports `signInWithRedirect`.
import 'aws-amplify/auth/enable-oauth-listener';

// TODO: it is really inconvenient that the FE needs this information (userPoolId, userPoolClientId etc.)
// i'm thinking more and more that a server side rendered solution would be a more appropriate
// way. An amplify based infrastructure would handle this for us.
// Also: This approach ends up in a one to one mapping between a frontend instance and an organisation/tenant.
// I think that is not what we want and probably won't scale.
Amplify.configure({
  Auth: {
    Cognito: {
      userPoolId: import.meta.env.PUBLIC_COGNITO_USER_POOL_ID,
      userPoolClientId: import.meta.env.PUBLIC_COGNITO_CLIENT_ID,
      loginWith: {
        oauth: {
          domain: import.meta.env.PUBLIC_COGNITO_OAUTH_DOMAIN,
          scopes: ['email', 'profile', 'openid'],
          redirectSignIn: [window.location.origin],
          redirectSignOut: [`${window.location.origin}/logout`],
          responseType: 'code', // note that a REFRESH token will only be generated when the responseType is code
        },
      },
    },
  },
});
